module.exports = __webpack_public_path__ + "static/img/86-2.281881c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/86-2.jpg
// module id = Idz2
// module chunks = 0